import {
    FETCH_CLAIMS_REQUEST,
    FETCH_CLAIMS_SUCCESS,
    FETCH_CLAIMS_FAILURE,
    FETCH_CHECK_CLAIMS_REQUEST,
    FETCH_CHECK_CLAIMS_SUCCESS,
    FETCH_CHECK_CLAIMS_FAILURE,
} from '../actions/claimsActions';

const initialState = {
    list: { data: null, loading: false, error: null },
    checkClaims: { data: null, loading: false, error: null },
};

const claimsReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_CLAIMS_REQUEST:
            return { ...state, list: { data: state.list.data, loading: true, error: null } };
        case FETCH_CLAIMS_SUCCESS:
            return { ...state, list: { data: action.payload, loading: false, error: null } };
        case FETCH_CLAIMS_FAILURE:
            return { ...state, list: { data: null, loading: false, error: action.payload } };
        case FETCH_CHECK_CLAIMS_REQUEST:
            return { ...state, checkClaims: { data: state.checkClaims.data, loading: true, error: null } };
        case FETCH_CHECK_CLAIMS_SUCCESS:
            return { ...state, checkClaims: { data: action.payload, loading: false, error: null } };
        case FETCH_CHECK_CLAIMS_FAILURE:
            return { ...state, checkClaims: { data: null, loading: false, error: action.payload } };
        default:
            return state;
    }
};

export default claimsReducer;




